import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { home, editprofile, changepassword } from '../../Routes/routingConsts'
// import Layout from './Layout'

const MyAccountLayout = ({ children }) => {
    const { state } = useLocation()
    return (
        <div className="employee-myaccount-page sidebar-content">
            <div className="myaccount edit-profile">
                <div className="bread-crumb">
                    <ul>
                        <li>
                            <NavLink className="nav-link" to={home}>
                                Dashboard
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                className="nav-link"
                                to={editprofile}
                                state="Edit Profile"
                            >
                                My Account
                            </NavLink>
                        </li>
                        <li>
                            <NavLink className="nav-link">{state}</NavLink>
                        </li>
                    </ul>
                </div>
                <div className="custom-row">
                    <div className="myaccount-sidebar">
                        <ul>
                            <li>
                                <NavLink
                                    to={editprofile}
                                    className="nav-link"
                                    state="Edit Profile"
                                >
                                    Edit Profile
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={changepassword}
                                    className="nav-link"
                                    state="Change Password"
                                >
                                    Change Password
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default MyAccountLayout
